<template>
  <van-dialog v-model="isShowDialog" :confirmButtonText="ensureText" @close="close" @confirm="purchaseLikeNum" close-on-click-overlay>
    <div class="purchase-modal-content">
      <a href="javascript:;" class="close-btn" @click="close">
        <img class="close-icon" src="~@/assets/img/close.png" alt="" />
      </a>

      <h3 class="title">当前“喜欢”名额不足，请购买</h3>

      <div class="purchase-list">
        <a href="javascript:;"
          class="purchase-item"
          v-for="item in productList"
          :key="item.id"
          :class="{'selected' : item.id === selectKey}"
          @click="selectItem(item)"
        >
          <span class="num">{{item.name}}</span>
          <span class="price">￥{{transferPrice(item.currentPrice)}}</span>
        </a>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import wxApi from '@/utils/wxAuth'

export default {
  name: 'purchaseModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fix: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isShowDialog: false,
      selectKey: 0,
      ensureText: '立即支付'
    }
  },
  computed: {
    ...mapState('productList', ['productList'])
  },
  watch: {
    show: {
      handler (val) {
        if (val) {
          if (this.productList.length) {
            this.isShowDialog = val
          } else {
            this.fetchProductListOrWebchat({ type: 1 }).then(() => {
              this.isShowDialog = val
            }, err => {
              this.$toast(err)
              this.$emit('close')
            })
          }
        } else {
          this.isShowDialog = val
        }
      },
      immediate: true
    },
    selectKey: {
      handler (val) {
        const item = this.productList.find(_ => {
          return _.id === val
        })

        if (item) {
          this.ensureText = `立即支付 ￥${this.transferPrice(item.currentPrice)}`
        }
      },
      immediate: true
    },
    isShowDialog (val) {
      if (val && !this.selectKey) {
        this.selectKey = this.productList[0].id
      }
    }
  },
  methods: {
    ...mapActions(
      'productList',
      {
        fetchProductListOrWebchat: 'fetchProductListOrWebchat'
      }
    ),
    ...mapActions({
      fetchUserData: 'fetchUserData'
    }),
    transferPrice (val) {
      if (typeof val !== 'number') {
        return 0
      } else {
        return (val / 100).toFixed(this.fix)
      }
    },
    selectItem (item) {
      if (item.id === this.selectKey) {
        return
      }
      this.selectKey = item.id
    },
    close () {
      this.$emit('close')
    },
    async purchaseLikeNum () {
      let fd = new FormData()
      fd.append('productId', this.selectKey)
      this.$root.openLoading()
      try {
        let { code, data, msg } = await this.$http('/api/member/purchase/transaction', fd)
        if (!(code === '0000' && data)) {
          this.$root.closeLoading()
          this.$emit('fail')
          return this.$toast(msg)
        }
        // 微信支付
        this.$http('/api/login/wx/jssdk/config/get', {
          pageUrl: location.href
        }, 'get').then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            wxApi.init({
              appid: data.appId, // 正式测试号
              redirectUri: window.location.href
            }).wexinPay(data, res.data).then(res => {
              if (res.actionCode === 200) {
                this.$toast('支付成功')
                this.$emit('callback')
                // 支付成功后刷新用户资料操作
                this.$root.openLoading()
                this.fetchUserData().then(() => {
                  this.$root.closeLoading()
                }).catch(() => {
                  this.$root.closeLoading()
                })
              } else {
                this.$toast('您取消了支付')
                this.$emit('fail')
              }
            }).catch(e => {
              this.$toast('支付异常')
              this.$emit('fail')
            })
          } else {
            this.$emit('fail')
          }
        }, err => {
          this.$root.closeLoading()
          //this.$toast(err)
          this.$emit('fail')
        })
      } catch (err) {
        this.$root.closeLoading()
        //this.$toast(err)
        this.$emit('fail')
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  .purchase-modal-content {
    position: relative;
    padding: 40px 34px 28px;
    .close-btn {
      position: absolute;
      top: 24px;
      right: 24px;
      padding: 4px;
      width: 36px;
      height: 36px;
    }
    .close-icon {
      width: 100%;
      height: 100%;
    }
    .title {
      margin-bottom: 50px;
      font-size: 28px;
      line-height: 40px;
      font-weight: bold;
      text-align: center;
    }
    .purchase-list {
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
    }
    .purchase-item {
      flex: 0 1 230px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      padding: 18px 30px;
      border: 1px solid $mainColor;
      color: $mainColor;
      border-radius: 4px;
      .num {
        font-size: 32px;
        line-height: 44px;
      }
      .price {
        line-height: 32px;
      }
      &.selected {
        color: #fff;
        background: $mainColor;
      }
    }
  }
</style>
